import resolveBool from './resolveBool';
import resolveColorName from './resolveColorName';
import resolveContentBlocks from './resolveContentBlocks';
import resolveSpacingSize from './resolveSpacingSize';
import resolveTheme from './resolveTheme';

const resolveContentBlocksContainer = ({
  rawVal,
  page,
  pageModels,
}: PropsWithCMSProps<ContentBlocksContainerProps>): DetailContentContainerType[] => {
  const result = (rawVal || [])
    .map((raw) => {
      const {
        bottomSpacing,
        containerTopBackgroundColor,
        containerBottomBackgroundColor,
        'text-color': textColor,
        topSpacing,
        contentBlocks,
        containerInsetWidth,
        jumplink,
        anchorLabel,
      } = raw;

      return {
        topSpacing: resolveSpacingSize({ rawVal: topSpacing }),
        bottomSpacing: resolveSpacingSize({ rawVal: bottomSpacing }),
        topBackgroundColor: resolveColorName({ rawVal: containerTopBackgroundColor }),
        bottomBackgroundColor: resolveColorName({ rawVal: containerBottomBackgroundColor }),
        insetWidth:
          containerInsetWidth && containerInsetWidth.length > 0 ? containerInsetWidth : 'medium',
        theme: resolveTheme('text-color')({ rawVal: textColor }),
        jumplink: resolveBool({ rawVal: jumplink }),
        anchorLabel,
        content: resolveContentBlocks({ rawVal: contentBlocks, page, pageModels }),
      };
    })
    .filter((el) => Boolean(el)) as DetailContentContainerType[];

  return result;
};

export default resolveContentBlocksContainer;
